<template>
  <div>
    <div class="title">
      <span class="name">中外合作办学</span>
    </div>
    <span class="specialty_name" v-for="(item, i) in zhongwaiList" :key="i">
      {{ item.level }}
    </span>
  </div>
</template>

<script>
export default {
  name: '',
  data() {
    return {
      list: [],
      zhongwaiList: null,
    };
  },
  computed: {
  },
  created() {
    this.getShuang()
  },
  methods: {
    getShuang() {
      this.$fecth
        .get("school/getZhongwai", { params: { school_id: this.$route.query.cid } })
        .then((res) => {
          res = res.data
          if (res.length > 0) {
            this.zhongwaiList = res
          } else {
            this.$emit('getzhongwaiState', false)
          }
        });
    },
  },
};
</script>

<style scoped lang='less'>
.title {
  font-size: 22px;
  margin-bottom: 15px;

  .name {
    margin-right: 70px;
  }

  .title-t {
    border: 1px solid #4591F6;
    color: #4591F6;
    margin-right: 20px;
    padding: 2px 10px;
    border-radius: 5px;
    font-size: 18px;
  }
}

.specialty_name {
  background: #F5F5F5;
  display: inline-block;
  margin-top: 20px;
  margin-right: 20px;
  padding: 2px 5px;
  border-radius: 3px;
}
</style>
